enum Image {
  ADVENTURE = 'adventure',
  BEACH = 'beach',
  CASTLE = 'castle',
  CITY = 'city',
  COASTAL = 'coastal',
  COLORFUL_VILLAGE = 'colorful-village',
  FALL = 'fall',
  // FAMILY_TRIP = 'family-trip',
  // HOTEL = 'hotel',
  MOUNTAINS = 'mountains',
  NATURE = 'nature',
  PEACEFUL = 'peaceful',
  RELAXING = 'relaxing',
  RESORT = 'resort',
  ROMANTIC = 'romantic',
  SAILING = 'sailing',
  SEARCHING = 'searching',
  // SKI_SLOPE = 'ski-slope',
  SOLO_TRIP = 'solo-trip',
  SUNSET = 'sunset',
  SURFING = 'surfing',
  TROPICAL = 'tropical',
  WINTER = 'winter',
}

export { Image };
